const sizes = {
    mobile: '767px',
    tablet: '768px',
    smallDesktop: '1024px',
    desktop: '1025px'
}

export const media = {
    mobile: `(max-width: ${sizes.mobile})`,
    tablet: `(min-width:  ${sizes.tablet}) and (max-width: 1023px)`,
    tabletLandscape: `(min-width: ${sizes.tablet}) and (max-width: ${sizes.smallDesktop})`,
    desktop: `(min-width: ${sizes.desktop})`
}
export const device = {
  mobile: '(pointer: coarse)',
  desktop: '(pointer: fine)'
}